{
  "de": {
    "title": {
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "home": "Startseite",
      "ships": {
        "index": "Schiffe",
        "viewer": "Schiff Viewer"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "%{name} Bilder",
      "shipVideos": "%{name} Videos",
      "shipHistory": "%{name} Historie",
      "shipViewer": "%{name} Viewer",
      "images": "Bilder",
      "stats": "Statistiken",
      "login": "Anmelden",
      "signUp": "Registrieren",
      "embed": "Widget Einbetten",
      "apiV1": "API V1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Paginierung",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "hangar": {
        "index": "Mein Hangar",
        "preview": "Mein Hangar Vorschau",
        "stats": "Meine Hangar Statistiken",
        "import": "Importieren",
        "public": "%{user} Hangar",
        "publicStats": "%{user} Hangar Statistiken",
        "wishlist": "Wunschliste",
        "publicWishlist": "%{user} Wunschliste",
        "vehicleLoadouts": "Schiffs-Loadouts",
        "inventories": "Meine Hangar Inventare",
        "inventory": "%{inventory}",
        "vehicleCargo": "Schiffsfracht"
      },
      "requestPassword": "Passwort anfordern",
      "changePassword": "Passwort ändern",
      "fleets": {
        "add": "Neue Flotte erstellen",
        "preview": "Flotten Vorschau",
        "invites": "Flotten Einladungen",
        "members": {
          "index": "%{fleet} Mitglieder",
          "invites": "%{fleet} Einladungen",
          "worldmap": "%{fleet} Mitglieder-Weltkarte",
          "starmap": "%{fleet} Mitglieder-Sternenkarte"
        },
        "stats": "%{fleet} Statistiken",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories"
        },
        "missions": {
          "index": "%{fleet} Missionen",
          "create": "Mission erstellen - %{fleet}",
          "edit": {
            "basic": "Mission bearbeiten - %{fleet}",
            "description": "Beschreibung bearbeiten - %{fleet}",
            "teams": "Teams & Slots bearbeiten - %{fleet}"
          },
          "show": "%{fleet} Mission"
        },
        "events": {
          "index": "%{fleet} Events",
          "calendar": "%{fleet} Kalender",
          "create": "Event erstellen - %{fleet}",
          "edit": {
            "basic": "Event bearbeiten - %{fleet}",
            "description": "Beschreibung bearbeiten - %{fleet}",
            "teams": "Teams & Slots bearbeiten - %{fleet}"
          },
          "show": "%{fleet} Event"
        },
        "settings": {
          "index": "%{fleet} Einstellungen",
          "fleet": "%{fleet} Einstellungen",
          "membership": "%{fleet} Mitgliedschaft",
          "roles": "%{fleet} Rollen",
          "notifications": "%{fleet} Benachrichtigungseinstellungen",
          "discord": "%{fleet} Discord-Einstellungen",
          "calendar": "%{fleet} Kalendereinstellungen",
          "features": "%{fleet} Funktionen"
        }
      },
      "roadmap": {
        "index": "Roadmap",
        "ships": "Schiff-Roadmap",
        "changes": "Roadmap Änderungen"
      },
      "settings": {
        "index": "Profil Einstellungen",
        "profile": "Profileinstellungen",
        "account": "Konto",
        "hangar": "Hangar Einstellungen",
        "privacy": "Datenschutz-Einstellungen",
        "features": "Feature-Flags",
        "connections": "Verbindungen",
        "oauthApplications": "OAuth-Anwendungen",
        "notifications": "Benachrichtigungseinstellungen",
        "calendar": "Kalender-Abonnement",
        "security": "Konto Sicherheit",
        "twoFactor": {
          "enable": "Zwei-Faktor-Authentifizierung aktivieren",
          "disable": "Zwei-Faktor-Authentifizierung deaktivieren",
          "backupCodes": "Zwei-Faktor-Backup-Codes generieren"
        }
      },
      "compare": {
        "ships": "Schiffe vergleichen"
      },
      "notFound": "404",
      "tools": {
        "index": "Werkzeuge",
        "travelTimes": "Reisezeiten",
        "cargoGrids": "Frachtgitter"
      },
      "impressum": "Impressum",
      "privacyPolicy": "Datenschutzrichtlinie",
      "cookiePolicy": "Cookie-Richtlinie",
      "visualTests": {
        "index": "Visuelle Tests",
        "panels": "Panels - Visuelle Tests",
        "buttons": "Buttons - Visuelle Tests",
        "events": "Events",
        "typography": "Typografie - Visuelle Tests",
        "forms": "Formulare - Visuelle Tests",
        "tables": "Tabellen - Visuelle Tests",
        "lists": "Listen - Visuelle Tests",
        "metrics": "Metriken - Visuelle Tests",
        "states": "Zustände - Visuelle Tests",
        "notifications": "Benachrichtigungen - Visuelle Tests",
        "syncModal": "Sync-Modal - Visuelle Tests",
        "overlays": "Overlays - Visuelle Tests",
        "supportHint": "Support-Hinweis - Visuelle Tests",
        "media": "Medien - Visuelle Tests",
        "charts": "Diagramme - Visuelle Tests",
        "chips": "Chips - Visuelle Tests",
        "notificationCenter": "Benachrichtigungszentrale - Visuelle Tests"
      },
      "admin": {
        "models": {
          "index": "Modelle",
          "new": "Neues Modell",
          "edit": {
            "index": "%{manufacturer} %{model} bearbeiten",
            "metrics": "%{manufacturer} %{model} Metriken bearbeiten",
            "prices": "%{manufacturer} %{model} Preise bearbeiten",
            "fleetchart": "%{manufacturer} %{model} Flottendiagramm-Bilder bearbeiten",
            "positions": "%{manufacturer} %{model} Positionen bearbeiten",
            "hardpoints": "%{manufacturer} %{model} Hardpoints bearbeiten",
            "cargoAndFuel": "%{manufacturer} %{model} Treibstoff bearbeiten",
            "cargoHolds": "%{manufacturer} %{model} Frachträume bearbeiten",
            "docks": "%{manufacturer} %{model} Docks bearbeiten",
            "modules": "%{manufacturer} %{model} Module bearbeiten",
            "paints": "%{manufacturer} %{model} Lackierungen bearbeiten",
            "images": "%{manufacturer} %{model} Bilder bearbeiten",
            "videos": "%{manufacturer} %{model} Videos bearbeiten",
            "loaners": "%{manufacturer} %{model} Leihgaben bearbeiten",
            "snubCrafts": "%{manufacturer} %{model} Snub Crafts bearbeiten",
            "upgrades": "%{manufacturer} %{model} Upgrades bearbeiten",
            "packages": "%{manufacturer} %{model} Pakete bearbeiten",
            "history": "%{manufacturer} %{model} Verlauf"
          }
        },
        "components": {
          "index": "Komponenten",
          "new": "Neue Komponente",
          "edit": {
            "index": "Komponente bearbeiten",
            "prices": "Komponente Preise bearbeiten",
            "history": "Komponenten-Verlauf"
          }
        },
        "manufacturers": {
          "index": "Hersteller",
          "new": "Neuer Hersteller",
          "edit": {
            "index": "Hersteller bearbeiten"
          }
        },
        "supporterContributions": {
          "index": "Unterstützer-Beiträge",
          "new": "Neuer Beitrag",
          "edit": "Beitrag bearbeiten"
        },
        "fundingGoals": {
          "index": "Finanzierungsziele",
          "new": "Neues Finanzierungsziel",
          "edit": "Finanzierungsziel bearbeiten"
        },
        "users": {
          "index": "Benutzer",
          "edit": "Benutzer bearbeiten",
          "inventories": "Nutzer-Inventare",
          "inventory": "Nutzer-Inventar",
          "inventoryItem": "Inventar-Eintrag",
          "fleets": "Nutzer-Flotten"
        },
        "vehicles": {
          "index": "Fahrzeuge",
          "edit": "Fahrzeug bearbeiten"
        },
        "admins": {
          "index": "Administratoren",
          "new": "Neuer Admin",
          "edit": "Admin bearbeiten"
        },
        "fleets": {
          "index": "Flotten",
          "edit": "Flotte bearbeiten",
          "members": "Flottenmitglieder",
          "memberEdit": "Flottenmitglied bearbeiten",
          "history": "Flotten-Verlauf",
          "roles": "Flotten-Rollen",
          "role": "Flotten-Rolle",
          "inventories": "Flotten-Inventare",
          "inventory": "Flotten-Inventar",
          "inventoryItem": "Inventar-Eintrag"
        },
        "oauthApplications": {
          "index": "OAuth-Anwendungen",
          "new": "Neue OAuth-Anwendung",
          "edit": "OAuth-Anwendung bearbeiten"
        },
        "features": {
          "index": "Feature-Flags",
          "show": "Funktionsdetails"
        },
        "images": {
          "index": "Bilder"
        },
        "notifications": {
          "index": "Benachrichtigungen"
        },
        "maintenance": {
          "index": "Wartung",
          "pghero": "PgHero",
          "features": "Funktionen",
          "flipper": "Flipper UI",
          "workers": "Workers",
          "tasks": "Aufgaben",
          "imports": "Importe",
          "importDetail": "Import-Details",
          "rsiApiStatus": "RSI-API-Status"
        },
        "modelPaints": {
          "index": "Modell Lackierungen",
          "edit": "Modell Lackierung bearbeiten"
        },
        "modelModules": {
          "index": "Modell Module",
          "edit": {
            "index": "%{name} Basisdaten bearbeiten",
            "models": "%{name} Modelle bearbeiten",
            "prices": "%{name} Preise bearbeiten",
            "hardpoints": "%{name} Hardpoints bearbeiten",
            "cargoHolds": "%{name} Frachträume bearbeiten",
            "history": "Modul-Verlauf"
          }
        },
        "unlistedModels": {
          "index": "Nicht gelistete Schiffe"
        },
        "modelModulePackages": {
          "index": "Modell Modul Pakete"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "prices": "Edit Equipment Prices"
          }
        },
        "visualTests": {
          "index": "Visuelle Tests",
          "notifications": "Benachrichtigungen - Visuelle Tests"
        }
      },
      "notifications": "Benachrichtigungen"
    }
  }
}
